import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../axiosConfig";
import Modal from "bootstrap/js/dist/modal";
import PortalLogo from "./utils/PortalLogo";

const SignUpLayer = () => {
  const navigate = useNavigate();

  const [rfc, setRfc] = useState("");
  const [mail, setMail] = useState("");
  const [pass, setPass] = useState("");
  const [noEmpleado, setNoEmpleado] = useState("");
  const [autorizacion, setAutorizacion] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // 🔒 bloquea botón mientras envía
  const [showPass, setShowPass] = useState(false); // 👁 ver/ocultar contraseña

  const inicio = () => {
    const modalEl = document.getElementById("exampleModal");
    const myModal = Modal.getInstance(modalEl) || Modal.getOrCreateInstance(modalEl);
    myModal.hide();
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setError("");
    setLoading(true);

    try {
      const res = await api.post("/registro", {
        rfc,
        noEmpleado,
        autorizacion,
        mail,
        pass,
      });

      if (res.status === 200) {
        const modalEl = document.getElementById("exampleModal");
        const myModal = Modal.getInstance(modalEl) || Modal.getOrCreateInstance(modalEl);
        myModal.show();

        // Limpia el formulario
        setRfc("");
        setNoEmpleado("");
        setAutorizacion("");
        setMail("");
        setPass("");
      } else if (res.status === 498) {
        setError("Numero de autorización expirado o inválido.");
      } else if (res.status === 404) {
        setError("Numero de autorización o RFC invalido.");
      } else {
        setError("No se pudo crear la cuenta. Si el problema persiste contacte al administrador.");
      }
    } catch (err) {
      // Intenta leer el código desde el error
      const status = err?.response?.status;
      if (status === 498) {
        setError("Numero de autorización expirado o inválido.");
      } else if (status === 404) {
        setError("Numero de autorización o RFC invalido.");
      } else {
        setError("No se pudo crear la cuenta. Si el problema persiste contacte al administrador.");
      }
      console.error("Error en registro:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="assets/images/auth/auth-img.png" alt="" />
        </div>
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <div className="text-center mb-5">
              <div className="row">
                <div className="col-md-4" />
                <div className="col-md-4">
                  <div className="mb-3">
                    <PortalLogo />
                  </div>
                </div>
                <div className="col-md-4" />
              </div>
              <h4 className="mb-5 text-primary-600">Portal del Trabajador</h4>
            </div>

            <h5 className="mb-12 text-primaru-600">Crear cuenta</h5>
            <p className="mb-32 text-secondary-light text-lg">
              Introduce tu información y el código de autorización generado por el administrador.
            </p>

            {error && <div className="alert alert-danger text-sm mb-16">{error}</div>}
          </div>

          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="f7:person" />
              </span>
              <input
                type="text"
                className="form-control h-56-px bg-neutral radius-12"
                placeholder="RFC"
                value={rfc}
                onChange={(e) => setRfc( e.target.value )}
                onBlur={ (e) =>  setRfc((s) =>  s.toUpperCase()   )   }
                required
                minLength={12}
                maxLength={13}
              />
            </div>

            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="f7:person" />
              </span>
              <input
                type="text"
                className="form-control h-56-px bg-neutral radius-12"
                placeholder="No. Empleado"
                value={noEmpleado}
                onChange={(e) => setNoEmpleado(e.target.value)}
                required
                minLength={4}
                maxLength={8}
              />
            </div>

            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral radius-12"
                placeholder="Correo electrónico"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                required
                maxLength={150}
              />
            </div>

            <div className="mb-20">
              <div className="position-relative">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral radius-12"
                    id="autorizacion"
                    placeholder="Código de autorización"
                    value={autorizacion}
                    onChange={(e) => setAutorizacion(e.target.value)}
                    required
                    minLength={5}
                  />
                </div>
              </div>
            </div>

            {/* Contraseña con toggle mostrar/ocultar */}
            <div className="mb-20">
              <div className="position-relative">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type={showPass ? "text" : "password"}
                    className="form-control h-56-px bg-neutral radius-12 pe-48" // espacio para el botón del ojo
                    id="your-password"
                    placeholder="Contraseña"
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                    required
                    minLength={8}
                  />
                </div>

                {/* Botón ojo */}
                <button
                  type="button"
                  className="position-absolute end-0 top-50 translate-middle-y me-16 border-0 bg-transparent text-secondary-light"
                  onClick={() => setShowPass((s) => !s)}
                  aria-label={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
                  title={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
                >
                  <Icon icon={showPass ? "mdi:eye-off-outline" : "mdi:eye-outline"} width="22" height="22" />
                </button>
              </div>
            </div>

            <div>
              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-start">
                  <input
                    className="form-check-input border border-neutral-300 mt-4"
                    type="checkbox"
                    id="condition"
                    required
                  />
                  <label className="form-check-label text-sm" htmlFor="condition">
                    Al crear mi cuenta, declaro bajo protesta que la información proporcionada es verídica y que tengo la facultad para registrarla.
                  </label>
                </div>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary-50 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading}
            >
              {loading ? "Enviando…" : "Enviar"}
            </button>

            <div className="mt-32 center-border-horizontal text-center">
              <span className="bg-base z-1 px-4">o</span>
            </div>

            <div className="mt-32 text-center text-sm">
              <p className="mb-0">
                ¿Ya tienes una cuenta?{" "}
                <Link to="/" className="text-primary-600 fw-semibold">
                  Inicio de sesión
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>

      {/* Modal */}
      <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-40 text-center">
              <div className="mb-32">
                <img src="assets/images/auth/envelop-icon.png" alt="" />
              </div>
              <h6 className="mb-12 text-primary-600">Cuenta creada correctamente</h6>
              <p className="text-secondary-light text-sm mb-0">
                Cuenta creada correctamente, ya puedes iniciar sesión para obtener tus comprobantes.
              </p>
              <button
                type="button"
                className="btn btn-primary-50 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                onClick={inicio}
              >
                Inicio de sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUpLayer;